import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import type { ImportRun, ImportRunDetail, ServiceTokenInfo } from './types';

// Hooks de suivi des imports. En lecture seule ; l'ingestion elle-meme passe
// par l'API protegee par token de service (n8n / depot de fichier).

export function useImportRuns(options: { refetchMs?: number } = {}) {
  return useQuery({
    queryKey: ['import-runs'],
    queryFn: () => api.get<ImportRun[]>('/import-runs'),
    // Rafraichissement leger : le suivi doit refleter les imports recents.
    refetchInterval: options.refetchMs ?? 15_000,
  });
}

export function useImportRun(id: number | null) {
  return useQuery({
    queryKey: ['import-runs', id],
    queryFn: () => api.get<ImportRunDetail>(`/import-runs/${id}`),
    enabled: id != null,
  });
}

export function useServiceTokens() {
  return useQuery({
    queryKey: ['service-tokens'],
    queryFn: () => api.get<ServiceTokenInfo[]>('/service-tokens'),
  });
}
